import { render, staticRenderFns } from "./device.vue?vue&type=template&id=3065f8dd&scoped=true"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"
import style0 from "./device.vue?vue&type=style&index=0&id=3065f8dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3065f8dd",
  null
  
)

export default component.exports